import { FC } from "react";
import { Alert, AlertDescription, AlertTitle, Button } from "@altimateai/lego";
import { IconExternalLink } from "@tabler/icons-react";

export const FirstTimeSetupAlert: FC = () => {
  return (
    <div className="al-space-y-3">
      <Alert variant={"warning"}>
        <AlertTitle className={"al-text-base"}>First-time setup:</AlertTitle>
        <AlertDescription>
          You have multiple Snowflake connections. Please create a Datamate and configure which
          connections it should use.
        </AlertDescription>
      </Alert>
      <Button className="al-w-full" onClick={() => window.open("/datamates/create", "_blank")}>
        Create Your First Datamate
        <IconExternalLink />
      </Button>
    </div>
  );
};
